module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wedding_checklist-df2eb6656b7c1eb7577664884f098ba3.svg";